if (!customElements.get('op-cross-sell-popup')) {
    class OpCrossSellPopup extends HTMLElement {
        connectedCallback() {
            subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
                const productHandle = payload.productHandle;
                const accessoriesGrid = this.closest(`[data-accessory-handle="${productHandle}"]`);
                

                if (accessoriesGrid) {
                    document.querySelector(`cart-drawer ${this.tagName}`).replaceWith(accessoriesGrid.querySelector(this.tagName))
                }
                
                this.classList.remove('tw-hidden');
                this.classList.add('tw-block', 'tw-animate-fade-in');
            });

            document.addEventListener('cart-drawer:close', () => {
                this.classList.add('tw-hidden');
                this.classList.remove('tw-block', 'tw-animate-fade-in');
            }
            );
        }
    }
    customElements.define("op-cross-sell-popup", OpCrossSellPopup);
}